<template>
  <div class="price-inquiry-detail">
    <div class="content">
         <!-- <el-empty description="暂无数据"></el-empty> -->
         	<el-form class="prod-form" label-width="140px" :rules="rules" ref="priceIquiryForm" size="small" :model="formData">
        <div style="display:flex;align-items:center;padding:10px;box-shadow:0px 2px #eee">
            <el-button @click="goBack" style="margin-bottom:18px;">返回</el-button>
            <el-form-item  label="询价标题：" prop="inquiryTitle">
                <el-input v-model="formData.inquiryTitle"  v-titletip="formData.inquiryTitle" class="truncate-input"  type="text"  placeholder="请输入询价标题" style="width:500px;"></el-input>
            </el-form-item>
            <el-form-item>
            <el-button type="primary" @click="saveData('1')">询价发出</el-button>
            </el-form-item>
        </div>
        <div style="display: flex;">
            <div class="form-content">
              <el-card class="box-card">
                <div slot="header" class="header">
                  <span>产品信息</span>
                </div>
               <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="产品名称及型号" prop="productNameModel">
                    <el-input v-model="formData.productNameModel"  type="text"  placeholder="请输入" style="width:500px;"  v-titletip="formData.productNameModel" class="truncate-input"></el-input>
                    <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="需明确工业品的标准名称（避免俗称），并提供准确型号（如设备型号、材料牌号、零件编号等）。例如：“型号为 XK-300 的不锈钢离心泵”“牌号 304、厚度 2mm 的冷轧钢板”。若有行业通用代号或客户内部编码，也需一并提供。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                    
                  </el-form-item>
                   <el-form-item label="规格与技术参数" prop="specificationsParameters">
                    <el-input  v-titletip="formData.specificationsParameters" class="truncate-input" v-model="formData.specificationsParameters"  type="text"  placeholder="请输入" style="width:500px;"></el-input>
                     <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="详细描述产品的物理 / 化学参数、尺寸（长 × 宽 × 高）、性能指标（如功率、压力、精度、耐温范围等）。例如：“齿轮箱转速 1500r/min，额定扭矩 500N・m”。若涉及定制化需求（如特殊材质、接口改造、功能增减），需明确说明定制细节。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                   <el-form-item label="执行标准" prop="executionStandard">
                    <el-input  v-titletip="formData.executionStandard" class="truncate-input" v-model="formData.executionStandard"  type="text"  placeholder="请输入" style="width:500px;"></el-input>
                     <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="注明产品需符合的标准（如国标 GB、行标 JB、国际标准 ISO、客户企业标准等），或是否需要通过特定认证（如 CE、UL、CCC、ISO9001 等）。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                </div>
                <div style="margin-left: 20px;">

                  <!-- <el-form-item> -->
                    <div v-if="imgUrl &&imgLoaded== true" class="upload-box"><img width="100%" :src="imgUrl" @load="imgLoaded=true" @error="handleImgErr"/><i class="el-icon-circle-close close-img-btn" @click="deleteImg"></i></div>
                    <div  v-if="!imgUrl || imgLoaded== false " class="upload-box" @click="upload">
                      <i  v-if="!imgLoading" class="el-icon-plus"></i>
                      <i  v-if="imgLoading" class="el-icon-loading"></i>
                      <div v-if="imgLoading" class="upload-text"><span>图片上传中...</span></div>
                      <div v-if="!imgLoading" class="upload-text"><span>上传产品图片</span></div>
                      <!-- <div v-if="!imgLoaded" class="upload-text" style="color:red"><span>重新上传图片</span></div> -->
                      
                      </div>
                  <!-- </el-form-item> -->
                </div>
               </div>
              </el-card>
               <el-card class="box-card">
                <div slot="header" class="header">
                  <span>采购数量与需求周期</span>
                </div>
               <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="本次预计采购数量" prop="estimatedPurchaseQuantity">
                    <el-input  v-titletip="formData.estimatedPurchaseQuantity" class="truncate-input" v-model="formData.estimatedPurchaseQuantity"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                     <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="明确单次采购数量（如“100 台”“500kg”），若为长期合作，需说明预估总需求量或分批次采购计划（如 “首单 200 套，后续每月补货 100 套”）。数量直接影响报价（量大可能有折扣），需准确无误。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                   <el-form-item label="要求交货时间" prop="requiredDeliveryTime">
                    <el-input  v-titletip="formData.requiredDeliveryTime" class="truncate-input" v-model="formData.requiredDeliveryTime"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                     <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="要求的最晚交货日期（如 “2025 年 9 月 30 日前”），若有分批次交货需求，需注明每批的数量和时间。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                   <el-form-item label="要求运输方式" prop="transportRequirements	">
                    <el-input  v-titletip="formData.transportRequirements" class="truncate-input" v-model="formData.transportRequirements	"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                     <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="要求的运输方式（如一般快递、汽运、海运、空运），或是否由供应商安排运输（需注明运费是否包含在报价中）。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="单位" prop="unit">
                    <!-- <el-input v-model="formData.unit"  type="text"  placeholder="请输入" style="width:250px;"></el-input> -->
                     <el-select v-model="formData.unit" placeholder="请选择" style="width:250px;">
                      <el-option
                        v-for="item in optionsUnit"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                     <!-- <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="明确本次采购数量的单位，例如：台、套、袋、箱、个等">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover> -->
                  </el-form-item>
                   <el-form-item label="交货地点" prop="deliveryLocation">
                    <el-input  v-titletip="formData.deliveryLocation" class="truncate-input" v-model="formData.deliveryLocation"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                    <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="具体地址（如 “XX 市 XX 区 XX 工厂仓库”），需明确是否包含卸货、入库等服务。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                   <el-form-item label="包装需求" prop="packagingRequirements">
                    <el-input  v-titletip="formData.packagingRequirements" class="truncate-input" v-model="formData.packagingRequirements"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                    <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="特殊包装需求（如防锈包装、出口木箱、标识要求等），避免运输过程中损坏。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                </div>
               </div>
              </el-card>
               <el-card class="box-card">
                <div slot="header" class="header">
                  <span>质量验收与付款结算</span>
                </div>
               <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="质量标准" prop="qualityStandard">
                    <el-input   v-titletip="formData.qualityStandard" class="truncate-input" v-model="formData.qualityStandard"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                     <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="除执行标准外，是否需要提供质检报告、出厂合格证、材质证明等文件。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                   <el-form-item label="付款方式" prop="paymentMethod">
                    <el-input  v-titletip="formData.paymentMethod" class="truncate-input" v-model="formData.paymentMethod"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                    <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="如预付款比例（如 “30% 预付款，70% 验收合格后付款”）、尾款支付节点（如 “发票后 30 天”），或是否接受信用证、承兑汇票等。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="验收方式" prop="inspectionMethod">
                    <el-input  v-titletip="formData.inspectionMethod" class="truncate-input" v-model="formData.inspectionMethod"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                    <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="明确验收依据（如按样品验收、按图纸验收），是否需要供应商配合现场调试、安装培训等。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                   <el-form-item label="报价有效期" prop="quotationValidityPeriod">
                    <el-input  v-titletip="formData.quotationValidityPeriod" class="truncate-input" v-model="formData.quotationValidityPeriod"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                    <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="要求供应商的报价在多长时间内有效（如 “报价有效期为 30 天”）。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                </div>
               </div>
              </el-card>
              <el-card class="box-card">
                <div slot="header" class="header">
                  <span>附加信息与附件</span>
                </div>
               <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="是否需要图纸或样品" prop="needDrawingsSamples">
                    <el-input  v-titletip="formData.needDrawingsSamples" class="truncate-input" v-model="formData.needDrawingsSamples"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                     <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="若产品复杂（如机械零件、定制设备），需提供设计图纸（CAD、PDF 等）、样品照片或实物样品，避免理解偏差。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="其他特殊要求" prop="otherSpecialRequirements">
                    <el-input  v-titletip="formData.otherSpecialRequirements" class="truncate-input" v-model="formData.otherSpecialRequirements"  type="text"  placeholder="请输入" style="width:250px;"></el-input>
                     <el-popover
                      placement="bottom"
                      title=""
                      width="350"
                      trigger="click"
                      content="如售后服务（保修期、维修响应时间）、备品备件需求、是否需要投标 / 比价等。">
                     <i class="el-icon-info tip-icon" slot="reference"></i>
                    </el-popover>
                  </el-form-item>
                </div>
               </div>
               <hr />
               <div>联系方式：</div>
                <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="姓名" prop="contactName">
                    <el-input  v-titletip="formData.contactName" class="truncate-input" v-model="formData.contactName"  type="text"  placeholder="请输入" style="width:150px;"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="联系电话" prop="contactPhone">
                    <el-input  v-titletip="formData.contactPhone" class="truncate-input" v-model="formData.contactPhone"  type="text"  placeholder="请输入" style="width:150px;"></el-input>
                  </el-form-item>
                </div>
                 <div>
                  <el-form-item label="邮箱" prop="email">
                    <el-input  v-titletip="formData.email" class="truncate-input"  v-model="formData.email"  type="text"  placeholder="请输入" style="width:150px;"></el-input>
                  </el-form-item>
                </div>
               </div>
              </el-card>
              <div class="footer"><el-button type="primary" size="small" @click="saveData('0')">保存询价</el-button></div>
            </div>
            <div class="right-dir  position-relative md-el-aside" v-resize-width>
              <div class="suplier-title">已选择供应商 <i v-if="inquiryCompanyList.length" @click.stop="emptyChoose" class="el-icon-delete empty-btn" title="清空选择供应商"></i></div>
              <el-tag
              style="cursor: pointer;"
                v-for="tag in inquiryCompanyList"
                :key="tag.iD"
                closable
                @close="handleClose(tag)"
              >
                {{tag.compName}}
              </el-tag>
              <div class="type-box">
                <el-radio v-model="compType" label="1" @change="handleRadioChange">单一供应商询价</el-radio>
                <div v-if="compType === '1'">
                  <el-input placeholder="请输入供应商名称" v-model="compName" class="search-input">
                    <el-button slot="append" type="primary" size="small" icon="el-icon-search" @click="getSupplierList"></el-button>
                  </el-input>
                </div>
              </div>
              <div class="type-box"><el-radio v-model="compType" label="2" @change="handleRadioChange">指定多家供应商询价</el-radio></div>
              <div class="type-box"><el-radio v-model="compType" label="3" @change="handleRadioChange">全网询价</el-radio></div>
              <div style="font-size:14px;margin-top:10px;" @click="drawerVisible = true">
                <span style="color:#606266;">分类选择&nbsp;&nbsp;</span>
                <el-button size="small" style="min-width:100px;">{{curName||'请选择分类'}}&nbsp;&nbsp;
                  <i v-if="!curName" class="el-icon-arrow-down"></i>
                  <i  v-if="curName" class="el-icon-close" @click.stop="clearCatagory"></i>
                </el-button>
              </div>
              <div class="suplier-title">供应商列表(金牌优先)</div>
              <div>
                  <el-checkbox-group 
                    v-model="formData.inquiryCompanyIds"
                    :min="0"
                    :max="max"
                  >
                    <div  v-for="(item,idx) in supplierList" class="checkbox-item" :title="item.companyName" :key="idx" @change="(checked) => handleSingleCheckboxChange(checked, item)">
                      <el-checkbox :label="item.companyId" :key="item.companyId">{{item.companyName}}</el-checkbox>
                    </div>
                  </el-checkbox-group>
              </div>
               <div style="flex: 1;cursor: auto;"></div>
            </div>
        </div>
        </el-form>
    </div>
   <el-drawer
    title="我是标题"
    :visible.sync="drawerVisible"
    :with-header="false">
    <div>
      <class-composes @cidChange="companyCidChange"></class-composes>
    </div>
  </el-drawer>
  </div>
</template>

<script>
import {MessageBox,Message} from 'element-ui'
import {WinForm,CheckLibs} from '@digital-supply-chain/module'
import {UtilService,ApiService} from '@/libs'
import {UserService, PriceQuiryService, FileUploadObs, ImgUploadObs} from '@/service'

import TreeList from '@/components/dir-tree/tree-list.vue';
import ClassComposes from './class-composes.vue';

export default {
  data() {
    return {
      compName: '',
      cid:'',
      curName: '',
      compType: '1',
      drawerVisible: false,
      supplierList: [],
      eidtId: '',
      max: 1,
      // dirID:'',
      // dirName:'',
      formData: {
        inquiryTitle: '',
        inquiryCompanyIds: [], // 供应商
        productNameModel:'',
        specificationsParameters:'',
        executionStandard:'',
        estimatedPurchaseQuantity:'',
        requiredDeliveryTime:'',
        transportRequirements:'',
        unit:'台',
        deliveryLocation:'',
        packagingRequirements:'',
        qualityStandard:'',
        paymentMethod:'',
        inspectionMethod:'', 
        quotationValidityPeriod:'',
        needDrawingsSamples:'',
        otherSpecialRequirements:'',
        contactName:'', 
        contactPhone:'',
        email:'',
      },
      inquiryCompanyList: [], // 已选择企业数据
      rules: {
        inquiryTitle: [{ required: true, message: "请输入询价标题", trigger: "change" }],
        productNameModel: [{ required: true, message: "请输入产品名及规格", trigger: "change" }],
        estimatedPurchaseQuantity: [{ required: true, message: "请输入采购数量", trigger: "change" }],
        unit: [{ required: true, message: "请输入单位", trigger: "change" }],
        requiredDeliveryTime: [{ required: true, message: "请输入交货时间", trigger: "change" }],
        deliveryLocation: [{ required: true, message: "请输入交货地点", trigger: "change" }],
        paymentMethod: [{ required: true, message: "请输入付款方式", trigger: "change" }],
        quotationValidityPeriod: [{ required: true, message: "请输入报价有效期", trigger: "change" }],
        contactName: [{ required: true, message: "请输入姓名", trigger: "change" }],
        contactPhone: [{ required: true, message: "请输入电话", trigger: "change" }],
      },
      list: [],// 上传的产品
      imgUrl: '', // obs 生成的地址
      obsKey: '', // obs 生成的key
      fileType:'图片文件|*.png;*.gif;*.jpg;*jpeg', // 产品照片格式
      productInfo: {}, // 产品信息
      type: '',
      domain:  `${ApiService.ImageHost}`,
      domain2:  `${ApiService.OssLook}`,
      optionsUnit: ['台','套','袋','箱','个'],
      imgLoaded: true,
      imgLoading: false,
    }
  },
  components: { TreeList,ClassComposes },
  mounted() {
    this.eidtId = this.$route.query.id||'';
    // this. dirName = this.$route.query.dirName||'';
    // console.log( this.$route.query,'--- this.$route.query')
    this.type = this.$route.query.type;
    if(this.type === 'link') {
      this.handleLinkInfo();
    }
    
    this.getEditData();
  },
  methods: {
    handleImgErr(eve) {
      this.imgLoaded = false;
      Message.error('上传图片失败，请重新上传');
    },
    // 清空已选择供应商
    emptyChoose() {
       MessageBox.confirm('确定要清空已选择供应商?', '提示', {
              confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=> {
          this.inquiryCompanyList = [];
          this.formData.inquiryCompanyIds = [];
        })
      
    },
    // 清空分类
    clearCatagory() {
      this.cid = '';
      this.curName ='';
       this.getSupplierList();
    },
   goBack() {
      this.$router.push({
        path: '/priceInquiry/home', 
        query: {
          dirType: this.$route.query.dirType||'1',
        }
      });
   },
   // 增加图片渲染url
    returnImgUrl(url) {

      if(!url) return ''
      const strArr = ['prod/', 'series/', 'logo/', 'mx/', 'yb/', 'sw/', 'wx/', 'images/'];
      if(typeof url === 'number') {
        return ''
      }
      const containsAny = strArr.some(str => url.includes(str));
      if(containsAny) {
        return `${this.domain}/${url}_300x300.jpg`;
      }else {
        return  `${this.domain2}/${url}?x-oss-process=image/resize,w_300`
      }
    },
   // 编辑进入页面处理
   async getEditData() {
    const id = this.$route.query.id;
    if(id) {
      const res = await PriceQuiryService.getInquiryDetail({id});
      if(res.data) {
        const keys = Object.keys(this.formData);
        for(let key of keys) {
          this.formData[key] = res.data[key] ||(key === 'inquiryCompanyIds' ? []: '');
        }
        const urlKey = res.data.inquiryImages?.key||'';
        this.obsKey = urlKey;
        this.imgUrl = this.returnImgUrl(urlKey);

        this.inquiryCompanyList = res.data.inquiryCompanyList;
      }
    }
   },
   // 从产品详情跳转过来
   handleLinkInfo() {
   this.productInfo = this.$route.query.productInfo ? JSON.parse(this.$route.query.productInfo): {};
    const {iD, compName, ProdLogo,ProdName, skuName} = this.productInfo;
    this.formData = {
      ...this.formData,
      inquiryCompanyIds: [iD],
      inquiryTitle: ProdName,
      productNameModel: ProdName,
      specificationsParameters: skuName,
    }
    this.imgUrl = this.returnImgUrl(ProdLogo);
    this.obsKey = ProdLogo;
    this.inquiryCompanyList = [{iD,compName}]
    
   },
   // 已选供应商tag close
   handleClose(tag) {
    const ids = [...this.formData.inquiryCompanyIds];
    const curList = [...this.inquiryCompanyList]
    this.inquiryCompanyList =curList.filter(ele => ele.iD != tag.iD);
    this.formData.inquiryCompanyIds = ids.filter(id => id!= tag.iD);

   },
    // 处理供应商选择
    handleSingleCheckboxChange(checked, item) {
      const isChecked = checked.target.checked;
      const curList = [...this.inquiryCompanyList];
      const idx =curList.findIndex(ele => ele.iD == item.companyId);
      if(idx !== -1&&!isChecked) {
          curList.splice(idx, 1)
      }
      if(idx === -1 && isChecked) {
        // 如果是单一供应商。需要先清空已选供应商列表
        if(this.compType ==='1') {
          curList.pop();
        }
        curList.push({iD: item.companyId, compName: item.companyName})
      }

      this.inquiryCompanyList = [...curList]
    },
  
    // 删除照片
    deleteImg() {
      this.list = [];
      this.imgUrl  ='';
      this.obsKey = '';
    },
    handleRadioChange(value) {
      // 清空已选择供应商
      this.inquiryCompanyList = [];
      this.formData.inquiryCompanyIds = [];
      
      this.compType = value;
      this.max = value === '1' ? 1 : (value === '2' ? 5 : 10);
      this.getSupplierList();
    },

    companyCidChange(data) {
      this.drawerVisible = false;
      this.cid = data.cid;
      this.curName = data.CName;
      this.getSupplierList()
    },

      async getSupplierList() {
        if(this.compType === '3'&& !this.cid) {
          Message.warning('全网询价需要选择分类');
          return
        }
        const params = this.compType ==='1' ? { companyName: this.compName,cid: this.cid, page:1, perPage:10000}
                                            : { cid: this.cid, page:1, perPage:10000};
        // 多家供应商搜索金牌
        if(this.compType === '2') {
          params.levelName = '金牌';
        }
        const res = await PriceQuiryService.getCompanyList(params);
        this.supplierList = res.data && res.data.list || [];
        this.formData.inquiryCompanyIds = [];
      },

        // 附件上传
    async upload() {
      let selectFilePaths = WinForm.md.openFileDlg(true, this.fileType);
      if (selectFilePaths == "failed" || !selectFilePaths.length) return;
      this.imgLoading = true;

      const paths = JSON.parse(selectFilePaths);

      const fileList = WinForm.md.getFileInfos(paths, 110); //获取文件信息集合
      var data = this.fomateDirData(fileList).map((x) => {
        var _names = x.Name.split(".");
        x.FileName = _names.splice(0, _names.length - 1).join(".");
        x.show = false;
        return x;
      });

      this.list.push(...data);
      const uploadedFiles = await FileUploadObs.uploadFiles({
        files: data,
        oneDoneFn: (item) => {
          console.log(item, 'uuuuuu')
          if (item.Percent == 100) {
            var data = this.list.filter((x) => {
              return x.Path == item.Path;
            });
            data.forEach((x) => {
              x.Saved = true;
            });
          }
          console.info("进度:", item, item.Saved, item.IsError, item.ErrorMsg);
        },
        
        // 获取上传图片时 obs 生成的地址
        getUploadAdressFn: (item)=>{
          // if(!item) {
          //   this.imgLoaded = false;
          //   Message.error('图片上传失败请重新上传')
          //   return;
          // }

          this.imgLoading = false;
          this.imgLoaded = true;
          this.imgUrl = `${item.options.displayDomain}/${item.options.key}?x-oss-process=image/resize,w_300`;
          this.obsKey = item.options.key;
          
        }
      });
      console.log(uploadedFiles, 'uploadedFiles')
		},
		fomateDirData(datas, path, dirid) {
      let nonLimitSize = 50 * 1024 * 1024;
			let files = [];
			datas.forEach((item) => {
				let filesize = Number(item.FileSize);
				item.OverSized = filesize > nonLimitSize; // 该文件是否超大
				// item.Title = item.OverSized ? SyncService.nonLimitTip : "";
				item.Size = filesize ? UtilService.fileSizeFormat(filesize) : "";
				item.FileSize = filesize;
				item.FileExt = item.FileExt.toLowerCase();
				item.Checked = false; // 文件是否选中
				item.Percent = -1; // 文件进度
				item.ErrorMsg = ""; // 文件进度
				item.IsError = false;
				item.Saved = false; // 文件是否保存过
				if (dirid !== undefined) item.DirID = dirid;
				files.push(item);
			});
			return files;
		},

    // 保存接口
    async saveData(status) {
       this.$refs['priceIquiryForm'].validate( async(valid) => {
        if(!valid) { 
          return; 
        }
        if(!this.obsKey) {
          Message.warning('请上传产品图片')
          return
        }
        if(this.inquiryCompanyList.length < 1) {
          Message.warning('请选择供应商')
          return
        }
        const ids = this.inquiryCompanyList.map(item => item.iD);
        const {inquiryCompanyIds, ...submitFormData} =this.formData;
        const data = {...submitFormData ,inquiryCompanyIds: ids, inquiryImages: {key: this.obsKey}, status, id:this.eidtId}
        
        const res = await PriceQuiryService.saveInquiryCreate(data)
        if(res.code === 0) {
          this.goBack()
        }
       })
    },
  }
}
</script>

<style lang="less" scoped>
.empty-btn {
  float: right;
  margin-right: 20px;
  font-size: 20px;
  line-height: 30px;
}
.empty-btn:hover {
  color: #409EFF;
  cursor: pointer;
}

.search-input{
  margin: 10px 0;
  width: 70%;
  min-width: 200px;
  
  ::v-deep .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  ::v-deep .el-input-group__append button.el-button{
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    border-radius: 0;
  }
}
.truncate-input  ::v-deep .el-input__inner {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.upload-box{
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
    text-align: center;
    font-size: 28px;
    color: #8c939d;
    position: relative;
}
.close-img-btn {
  position: absolute;
  right: -22px;
  top: -20px;
}
.upload-text {
  font-size: 14px;
  position: absolute;
  bottom: -50px;
  left: 0;
  text-align: center;
  width: 100%;
}
.content {
    flex: 1;
    overflow-x: hidden;
    // height: calc(100vh - 20px);
    // overflow-y: auto;
    ::v-deep .el-form-item.width-name label.el-form-item__label {
    font-size: 16px ;
    font-weight: 600;
  }
  ::v-deep .el-card__header {
    background: #F5F5F5;
    padding: 10px;
  }
  .footer {
    padding: 20px;
    text-align: right;
  }
}
.form-content {
  flex: 1;
  // height: calc(100vh - 60px);
   max-height: calc(100% - 60px);
    overflow-y: auto;
}
.type-box {
  margin: 10px 0;
}
.tip-icon {
  font-size: 18px;
  color:#409EFF;
  margin-left:8px;
}
.right-dir  {
    // height: calc(100vh - 60px);
    max-height: calc(100% - 60px);
    overflow-y: auto;
    // border-right: 6px solid #F2F2F2;
    max-width: 500px;
    min-width: 300px;
    cursor: ew-resize;
    display: flex;
    flex-direction: column;
    padding: 10px;
}

.price-inquiry-detail{
  display: flex;
  flex-direction: row;
  flex: 1;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
  /deep/ .el-divider--horizontal{
    margin: 0;
  }
}
.width-name {
    .el-input {
        width: 500px;
    }
    
}
.box-card {
  // margin-top: 10px;
  width: 100%;
   width: 100%;
  ::v-deep .el-card__body {
    padding: 10px;
  }
}
.suplier-title {
  padding-left: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 30px;
    line-height: 30px;
    background: #F5F5F5;
    cursor: pointer;
}
.checkbox-item {
  margin-bottom: 10px;

  ::v-deep .el-checkbox__label {
    white-space: nowrap;
    overflow: hidden;   
    text-overflow: ellipsis;
    width: 250px;
  }
}
.hide-upload-button ::v-deep div.el-upload--picture-card {
  display: none;
}

</style>
